"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.onMouseEnterTooltipDecorator = void 0;
require("react");
const measureText_1 = require("@veeam/components/lib/helpers/measureText");
const onMouseEnterTooltipDecorator = (tooltipHandler, ref) => {
    return () => {
        const { originalWidth, fullWidth } = measureText_1.measureText(ref);
        if (fullWidth > originalWidth) {
            tooltipHandler();
        }
    };
};
exports.onMouseEnterTooltipDecorator = onMouseEnterTooltipDecorator;
//# sourceMappingURL=onMouseEnterTooltipDecorator.js.map